import type { FC } from 'react';

import { Icon } from '~/components';
import { IconButton } from '~/components/IconButton';
import { Input, type InputProps } from '~/components/Input';
import { cn } from '~/lib/cn';

type SearchInputProps = InputProps & {
  className?: string;
  onClear?(): void;
};

export const SearchInput: FC<SearchInputProps> = ({
  className,
  placeholder,
  value,
  onClear,
  ...rest
}) => {
  return (
    <div className={cn('flex py-px items-center w-full', className)}>
      <Icon
        className="px-sm pl-md absolute"
        type="search"
        variant="light"
        size="sm"
        aria-label="search-icon"
        aria-hidden
      />
      <Input
        {...rest}
        value={value}
        className="italic placeholder-default pl-2xl py-sm text-lg text-body-sm"
        placeholder={placeholder}
      />
      <IconButton
        type="button"
        iconType="circle-x"
        size="small"
        className={cn(
          'right-sm absolute text-subtle hover:text-icon-strong',
          !value && 'hidden',
        )}
        onClick={onClear}
        aria-label="Clear search input"
      />
    </div>
  );
};

SearchInput.displayName = 'SearchInput';
